import React, {useEffect, useState} from 'react';
import Button from "react-bootstrap/lib/Button";
import Table from "react-bootstrap/lib/Table";
import {getActivityLogs, getActivityLogRestore} from "../api";
import {activityTypes} from "../constants";
import {ActivityLogModal} from "./modals/ActivityLogModal";

function SystemRestoreTab(props) {
    const [activityLogs, setActivityLogs] = useState([]);
    const [alertCreate, setAlertCreate] = useState(null);
    const [alertRestore, setAlertRestore] = useState(null);
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        getActivityLogs(activityTypes.SAVE, props.user.api_token, (data) => {
            setActivityLogs(data)
        })
    }, []);

    // Change alert panel when import has finished
    const onFinishCallback = (activityLog) => {
        setAlertCreate(
            <div className="alert alert-success"
                 role="alert">
                Restore point created succesfully!
            </div>);
        setActivityLogs([...activityLogs, activityLog]);
        setShowModal(false);
    };

    function onCreateRestoreClick(e) {
        setShowModal(true);
    }

    function onRestoreClick(activityId) {
        const callback = () => {
            alert("Restore point was loaded successfully!");
            window.location.reload();
        };
        setAlertRestore(
            <div className="alert alert-info"
                 role="alert">
                Loading restore point...
            </div>
        );
        getActivityLogRestore(activityId, props.user.api_token, callback)
    }

    return (
        <div>
            <ActivityLogModal show={showModal}
                              title="Create a restore point"
                              setShowModal={setShowModal}
                              onSaveCallback={onFinishCallback}
                              user={props.user}/>

            <Button bsStyle="success" onClick={onCreateRestoreClick}>Make a restore point</Button>
            {alertCreate}
            <h2>Available restore points</h2>

            <p>Here you can set the state of the entire application up to a certain point in the past based on restore
                points made so far.
            </p>

            <div>
                <Table striped bordered condensed hover>
                    <thead>
                    <tr>
                        <th>#</th>
                        <th>Timestamp</th>
                        <th>Description</th>
                        <th>Restore?</th>
                    </tr>
                    </thead>
                    <tbody>
                    {activityLogs.map((activity, index) => {
                        return (
                            <tr key={index}>
                                <td>{activity.id}</td>
                                <td>{activity.created_at}</td>
                                <td>{activity.data["description"]}</td>
                                <td>
                                    <span className="glyphicon glyphicon-refresh pointer"
                                          title="Restore this backup"
                                          onClick={(e) => onRestoreClick(activity.id)}>
                                    </span>
                                </td>
                            </tr>
                        )
                    })}
                    </tbody>
                </Table>
                {alertRestore}
            </div>
        </div>
    )
}

export default SystemRestoreTab
